import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent {
  loading = false;
  result: { Succeeded: boolean; Error?: string };
  defaultError = 'Something went wrong. Please check your email address and try again';

  forgotPasswordForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  constructor(private auth: AuthService, private route: ActivatedRoute, private fb: FormBuilder) {}

  async requestPasswordReset(val: any) {
    this.loading = true;
    this.result = await this.auth.forgotPassword(val.email).toPromise();
    this.loading = false;
  }
}
